module.exports = __webpack_public_path__ + "img/replay.580a412d.png";